import { render, staticRenderFns } from "./UpdateResourcePage.vue?vue&type=template&id=5b16b077&scoped=true"
import script from "./UpdateResourcePage.vue?vue&type=script&lang=js"
export * from "./UpdateResourcePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b16b077",
  null
  
)

export default component.exports